<!-- Dashboard start -->
<!-- END: Left Aside -->

<div
  class="m-grid__item m-grid__item--fluid m-wrapper"
  style="position: relative"
>
  <ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
      <span class="chevron left"></span>
      <span class="chevron right"></span>
      <p style="font-weight: bold; font-size:2rem; color: white; position: absolute; white-space: nowrap; text-align: center; width: 100%; left: -8px; top: 120px;">{{loadingMessage}}</p> 
  </ngx-spinner>

  <!--MAIN-->
  <div class="m-content" *ngIf="form">
    <!--begin::Portlet-->
    <div class="m-portlet">
      <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
          <div class="m-portlet__head-title">
            <h3 class="m-portlet__head-text" *ngIf="!id">
              SELFIE CAM DETAILS
            </h3>
            <h3 class="m-portlet__head-text" *ngIf="id">
              EDIT SELFIE CAM
            </h3>
            <span style="color: lightgray; vertical-align: middle; display: table-cell; text-align: right;" class="m-portlet__head-text" *ngIf="serviceId > 0">
              {{serviceId}}
            </span>
          </div>
        </div>
      </div>

      <!--begin::Form-->
      <form
        [formGroup]="form"
        class="m-form m-form--fit m-form--label-align-right"
      >
        <div class="m-portlet__body">
          <div class="m-form__section m-form__section--first">
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Selfie Cam Name:
              </label>
              <div class="col-lg-6">
                <input
                  type="text"
                  id="name"
                  class="form-control m-input"
                  formControlName="name"
                  placeholder=""
                />
                <app-validation-display
                  *ngIf="form.controls.name.value.length < 160"
                  [control]="form.controls.name"
                  errorMessage="Enter correct name"
                ></app-validation-display>
                <app-validation-display
                  *ngIf="form.controls.name.value.length > 160"
                  [control]="form.controls.name"
                errorMessage="Name is too long"
              ></app-validation-display>
              </div>
            </div>

            <div *ngIf="showServicePeriod" class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Period:
              </label>
              <div class="col-lg-8">
                <app-service-period
                  [minDays]="30"
                  formControlName="period"
                ></app-service-period>

                <div *ngIf="isExpired">
                  This selfie cam has completed and the period cannot be
                  changed. Click
                  <button (click)="duplicate()">duplicate</button> to make an
                  editable copy of this selfie cam.
                </div>
              </div>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <div class="col-lg-3 col-form-label"></div>
            <div>
              <div class="frame-container">
                <app-iphone-frame [styleOverride]="{'background': '#696969', 'color': '#fff' }">
                  <img
                    src="../../assets/app/media/img/icons/info-icon.png"
                    placement="right"
                    class="tooltip-icon"
                    style="position:absolute; left: -45px; top: 14px;"
                    tooltip="Click on the header to customize your text."
                  />
                  <img src="../../assets/app/media/img/icons/eye.png" class="tooltip-icon invert" style="position:absolute; left: -70px; top: 14px;" tooltip="Selfie Cam header will be seen by your audience">
                  <input type="text" class="frame1-top" formControlName="titleText" maxlength="20" />
                  <ng-template #durationTooltip>
                    Click on the countdown clock to customize your countdown
                    duration.
                    <br /><br />
                    We recommend:
                    <br /><br />
                    • 5 seconds for Selfie Cams that will be appended to the end
                    of a Light Show.
                    <br /><br />
                    • 15-30 seconds for standalone Selfie Cams (long enough to
                    catch late joiners).
                  </ng-template>
                  <img
                    src="../../assets/app/media/img/icons/info-icon.png"
                    placement="right"
                    class="tooltip-icon"
                    style="position: absolute; top: 170px; left: 10px; z-index:10"
                    [tooltip]="durationTooltip"
                  />
                  <input
                    type="text"
                    class="frame1-center-text"
                    value="{{
                      form.get('segments.0.duration').value | number: '1.1-1'
                    }}"
                    (input)="
                      form
                        .get('segments.0.duration')
                        .setValue($event.target.value);
                      form.get('segments.0.duration').markAsDirty()
                    "
                    type="number"
                    step="0.1"
                    min="5"
                  />
                  <div>
                    <ng-template #bottomImgTooltip>
                      Use the default “Smile” footer or click to upload a custom
                      footer for your organization or sponsor.
                      <br /><br />
                      Footer images must be PNG format and sized to 720px width
                      by 270px height.
                    </ng-template>
                    <img
                      src="../../assets/app/media/img/icons/info-icon.png"
                      placement="right"
                      class="tooltip-icon"
                      style="position: absolute; left:-45px; top: 314px;"
                      [tooltip]="bottomImgTooltip"
                    />
                    <img src="../../assets/app/media/img/icons/eye.png" class="tooltip-icon invert" style="position:absolute; left: -70px; top: 314px;" tooltip="This image will be seen by your audience">
                    <label for="file-1" class="frame1-bottom-image-container">
                      <input
                        type="file"
                        (change)="bottomImgEntered($event.target.files)"
                        name="file-1[]"
                        id="file-1"
                        class="inputfile inputfile-3"
                        data-multiple-caption="{count} files selected"
                        accept=".png"
                      />
                      <img
                        *ngIf="!loadingSelfieBottomImg"
                        [src]="form.controls.bottomImageUrl.value"
                        class="frame1-bottom-image"
                      />
                      <ngx-loading
                        [show]="loadingSelfieBottomImg"
                      ></ngx-loading>
                    </label>
                  </div>
                </app-iphone-frame>
              </div>
              <div class="frame-container">
                <app-iphone-frame [styleOverride]="{'background': '#696969', 'color': '#fff' }">
                  <label class="frame1-top"></label>
                  <button
                    type="button"
                    class="prevFilterBtn"
                    (click)="prevFilter()"
                  >
                    <img
                      style="position: absolute; top: 90px; left: 5px; z-index: 2;"
                      alt=""
                      src="assets/app/media/img/icons/left_arrow.png"
                    />
                  </button>
                  <button
                    type="button"
                    class="nextFilterBtn"
                    (click)="nextFilter()"
                  >
                    <img
                      style="position: absolute; top: 90px; left: 50px; z-index: 2;"
                      alt=""
                      src="assets/app/media/img/icons/right_arrow.png"
                    />
                  </button>
                  <div class="filterBox">
                    <img
                      style="z-index: 2;"
                      *ngIf="currentFilter"
                      [src]="currentFilter?.url"
                    />
                    <img
                      style="z-index: 1; position: absolute;"
                      alt=""
                      src="assets/app/media/img/misc/selfie_sample.jpeg"
                    />
                  </div>
                  <img
                    class="frame2-bottom-image"
                    src="../../assets/app/media/img/misc/selfie-cam-bottom.png"
                  />
                </app-iphone-frame>
              </div>
              <div
                class="frame-container filter-panel"
                style="position:relative; padding: 5px; border-radius: 3px"
              >
                <ngx-loading [show]="loadingFilters"></ngx-loading>
                <div class="filter-panel-header">
                  <ng-template #createFilterTooltip>
                    Customize one of our quality stock filters by clicking on
                    "Create filter," or upload a your own unique filter by
                    clicking on "Add custom filter."
                    <br /><br />
                    Custom filters must be PNG format.
                    <br /><br />
                    Pro-Tip: Doing a themed Light Show (e.g., Pink Night)? Come
                    back anytime to change your filters!
                  </ng-template>
                  <img
                    src="../../assets/app/media/img/icons/info-icon.png"
                    class="tooltip-icon"
                    style="float: left; position: absolute; left: -25px; top: 14px;"
                    placement="top"
                    [tooltip]="createFilterTooltip"
                  />
                  <button
                    class="btn btn-success add-filter-btn"
                    (click)="openFilterCreationDialog()"
                    type="button"
                  >
                    Create filter
                  </button>
                  <input
                    type="file"
                    multiple
                    (change)="addFilters($event.target.files)"
                    name="add-filter-btn"
                    id="add-filter-btn"
                    class="inputfile inputfile-3"
                    accept=".png"
                  />
                  <label
                    for="add-filter-btn"
                    class="btn btn-success add-filter-btn"
                  >
                    Add custom filter
                  </label>
                </div>
                <div class="filter-panel-body" style="position:relative">
                  <div
                    formArrayName="filters"
                    *ngFor="let x of filters.controls; let i = index"
                  >
                    <div class="filter-item">
                      <button
                        type="button"
                        class="remove-filter-btn btn-danger"
                        (click)="deleteFilter(i)"
                      >
                        Delete
                      </button>
                      <div>
                        <img
                          [src]="x.value.url"
                          class="filter-list-image"
                          (click)="selectFilter(i)"
                        />
                      </div>
                      <div [formGroupName]="i">
                        <input
                          class="form-control"
                          type="text"
                          formControlName="name"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <span class="m-form__help" *ngIf="!form.controls.filters.valid">
                  Please enter at least three filters.
                  <img src="../../assets/app/media/img/icons/eye.png" class="tooltip-icon invert" style="position: relative; top: 0px" tooltip="Filter names will be seen by your audience">
                </span>
              </div>
              <div class="col-lg-6 col-form-label">
                <app-validation-display
                  [control]="form.get('segments.0.duration')"
                ></app-validation-display>
              </div>
            </div>
          </div>

          <div class="form-group m-form__group row">
            <label class="col-lg-4 col-form-label">
              Share text:
            </label>
            <div class="col-lg-4">
              <input
                formControlName="shareText"
                type="text"
                class="form-control"
              />
              <app-validation-display
                *ngIf="form.controls.shareText.value.length > 160"
                [control]="form.controls.shareText"
                errorMessage="Share name is too long"
              ></app-validation-display>
              <app-validation-display
                *ngIf="form.controls.shareText.value.length < 160"
                [control]="form.controls.shareText"
                errorMessage="Enter Share name"
              ></app-validation-display>
              <ng-template #shareTextTooltip>
                Insert custom text or hashtags that will automatically embed in
                all social media posts.
                <br /><br />
                Pro-Tip: Doing a themed Light Show (e.g., Pink Night)? Come back
                anytime to change your hashtags!
              </ng-template>
              <img src="../../assets/app/media/img/icons/eye.png" class="tooltip-icon invert" style="float: right; position: relative; top: -28px; right: -55px;" tooltip="Share text will be seen by your audience">
              <img
                src="../../assets/app/media/img/icons/info-icon.png"
                class="tooltip-icon"
                style="float: right; position: relative; top: -28px; right: -60px;"
                placement="top"
                [tooltip]="shareTextTooltip"
              />
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-lg-4 col-form-label">
              <ng-template #embedInMusicToolTip>
                You can add your selfie cam to the end of a pre-existing light
                show, or, if you'd like to include it in a song, simply click on
                "CUSTOM MP3" and select where you would like the selfie cam to
                take place within the track.
              </ng-template>
              <img
                src="../../assets/app/media/img/icons/info-icon.png"
                class="tooltip-icon"
                placement="top"
                [tooltip]="embedInMusicToolTip"
              />
              Embed in music:
            </label>
            <div class="col-lg-2 startdateinput">
              <label class="switch">
                <input
                  formControlName="embedMusic"
                  id="shouldNotifyUserCreated"
                  type="checkbox"
                  class="form-control"
                  style="display:none"
                  (change)="onEmbedMusicChanged()"
                />
                <span class="slider round"></span>
              </label>
            </div>
          </div>
          <div [hidden]="!form.controls.embedMusic.value">
            <div class="form-group m-form__group row">
              <div class="col-lg-3 col-form-label"></div>
              <div class="col-lg-6 col-form-label">
                <tabset>
                  <tab
                    heading="Custom mp3"
                    id="tab1"
                    (click)="onSelectMp3()"
                  >
                    <ngx-loading [show]="loadingMp3"></ngx-loading>
                    <div>
                      <input
                        type="file"
                        (change)="uploadMp3($event.target.files)"
                        name="upload-mp3-btn"
                        id="upload-mp3-btn"
                        class="inputfile inputfile-3"
                        accept=".mp3"
                      />
                      <label for="upload-mp3-btn" class="btn btn-success">
                        + Upload mp3
                      </label>
                      <span>{{ mp3FileName }}</span>
                      <app-validation-display
                        [control]="form.controls.embedMp3Url"
                      ></app-validation-display>
                    </div>
                    <div #main>
                      <label class="col-lg-4 col-form-label"></label>
                      <div>
                        <app-mp3-player [editorMode]="'SCREEN'" [main]="main" timeFactorMs="1000" [url]="form.controls.embedMp3Url.value" [segmentsFormArray]="form.get('segments')" [useForLightshowEditor]="false" >                        </app-mp3-player>
                      </div>
                    </div>
                  </tab>
                </tabset>
              </div>
            </div>
          </div>
          <app-coupon-select
            (change)="couponChange()"
            [couponSelectLabel]="'Participation Coupon'"
            [(selectedCouponId)]="form.controls.couponId.value"
          ></app-coupon-select>
          <div
            [hidden]="form.controls.couponId.value < 1"
            class="form-group m-form__group row"
          >
            <label class="col-lg-4 col-form-label">
              Coupon Message Title:
            </label>
            <div class="col-lg-6">
              <input
                [requiredIf]="form.controls.couponId.value > 0"
                type="text"
                id="forwardingTitle"
                class="form-control m-input"
                formControlName="forwardingTitle"
                placeholder=""
              />
              <app-validation-display
                errorMessage="Required for the Participation Coupon"
                [control]="form.controls.forwardingTitle"
              ></app-validation-display>
            </div>
          </div>
          <div
            [hidden]="form.controls.couponId.value < 1"
            class="form-group m-form__group row"
          >
            <label class="col-lg-4 col-form-label">
              Coupon Message Body:
            </label>
            <div class="col-lg-6">
              <input
                [requiredIf]="form.controls.couponId.value > 0"
                type="text"
                id="forwardingBody"
                class="form-control m-input"
                formControlName="forwardingBody"
                placeholder=""
              />
              <app-validation-display
                errorMessage="Required for the Participation Coupon"
                [control]="form.controls.forwardingBody"
              ></app-validation-display>
            </div>
          </div>
          <div
            *ngIf="hasSiteManagement && id > 0"
            class="form-group m-form__group row"
          >
            <label class="col-lg-4 col-form-label">
              Regenerate Audio on Update:
            </label>
            <div class="col-lg-6">
              <label class="switch">
                <input
                  formControlName="regenerateAudio"
                  type="checkbox"
                  class="form-control"
                />
                <span class="slider round"></span>
              </label>
            </div>
          </div>
          <div
            *ngIf="hasSiteManagement"
            class="form-group m-form__group row"
          >
            <label class="col-lg-4 col-form-label">
              Use Audible Triggers:
            </label>
            <div class="col-lg-6">
              <label class="switch">
                <input
                  formControlName="useAudible"
                  type="checkbox"
                  class="form-control"
                />
                <span class="slider round"></span>
              </label>
            </div>
          </div>
          <div
              *ngIf="hasSiteManagement"
              class="form-group m-form__group row"
            >
            <label class="col-lg-4 col-form-label">
              Trigger Insertion Pattern:
            </label>
            <div class="col-lg-6">
              <input
                type="text"
                id="insertionPattern"
                autocomplete="false"
                class="form-control m-input"
                formControlName="insertionPattern"
                placeholder=""
              />
              <app-validation-display
                  errorMessage="Invalid insertion pattern list. ex 1, 2, 3"
                  [control]="form.controls.insertionPattern"
                ></app-validation-display>
            </div>
            </div>
        </div>
      </form>
      <div class="m-portlet__body" style="padding:0 30px 30px 30px">
        <div class="form-group m-form__group row">
          <label class="col-lg-4 col-form-label" style="text-align: right;">
            Coupon Code:
          </label>
          <div class="col-lg-1">
            <app-coupon-code [(ngModel)]="couponCode"></app-coupon-code>
          </div>
          <img
            *ngIf="couponValid && priceFetched"
            src="../../assets/app/media/img/icons/checked.svg"
            style="height: 100%; width:35px;"
          />
        </div>
      </div>
      <div class="col-lg-8">
        <app-validation-display
          [control]="form.controls.filters"
          errorMessage="Please specify at least %minLengthArray% filters"
        ></app-validation-display>
      </div>
    </div>
    <button [disabled]="loading" (click)="checkout()" type="button" class="btn btn-primary">
      {{ id ? "Update" : "Create" }}
    </button>
    <button (click)="cancel()" type="button" class="btn btn-danger" style="margin-left: 15px;">
      Cancel
    </button>
    <app-network-sync (showSpinner)="setSpinnerState($event)" (spinnerMessage)="setLoadingMessage($event)" [serviceId]="serviceId" [displayCountdown]="true" [viewRef]="viewRef" [serviceName]="'Selfie Cam'" [controllerPath]="'selfie-cam'"></app-network-sync>
    <button
      *ngIf="id > 0 && hasPhotos"
      (click)="viewSelfies(id, serviceId)"
      style="margin-bottom: 15px; margin-right: 30px; float: right"
      type="button"
      class="btn btn-success"
    >View Selfies</button>

  </div>
</div>
